import { createFileRoute, useRouter } from "@tanstack/react-router";
import { useServerFn } from "@tanstack/react-start";
import { useState } from "react";
import { makeMeAdmin } from "@/lib/setup-admin.functions";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export const Route = createFileRoute("/_authenticated/setup-admin")({
  component: SetupAdminPage,
});

function SetupAdminPage() {
  const router = useRouter();
  const [result, setResult] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const makeAdmin = useServerFn(makeMeAdmin);

  const handleMakeAdmin = async () => {
    setLoading(true);
    try {
      const res = await makeAdmin({ data: {} });
      setResult(res.message);
      router.invalidate();
    } catch (err: any) {
      setResult("Fout: " + (err.message || "Onbekende fout"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-[60vh] items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>Admin Setup</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-muted-foreground">
            Klik op de knop hieronder om jezelf admin te maken.
          </p>
          <Button onClick={handleMakeAdmin} disabled={loading} className="w-full">
            {loading ? "Bezig..." : "Maak mij admin"}
          </Button>
          {result && (
            <p className="text-sm font-medium text-center">{result}</p>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
